import { Component, Host, Prop, h, State } from '@stencil/core';
import { DomService } from '../../services';
import { TrackingService } from '../../services/tracking';
import { TrackingObjectBuilder } from '../../services/tracking/tracking-object-builder';

@Component({
  tag: 'rcm-social-media-links',
  styleUrl: 'rcm-social-media-links.scss',
  shadow: true,
})
export class RcmSocialMediaLinks {
  @Prop() highContrast;

  @State() currentKey: string;

  handleOnLeave() {
    this.currentKey = '';
  }

  handleOnEnter(key) {
    this.currentKey = key;
  }

  handleTracking(social: { icon: string; link: string; altText: string }) {
    TrackingService.push(
      new TrackingObjectBuilder()
        .forLinkClick({ clickText: social.altText, clickUrl: social.link, parentComponent: 'rcm-social-media-links' })
        .build(),
    );
  }

  render() {
    const { socialMediaLinks, socialMediaLabel } = DomService.getGlobalContent().footer;
    const hasIcons = Object.entries(socialMediaLinks).some(([key, social]: any) => social.icon);

    return !hasIcons ? null : (
      <Host>
        <div class="social">
          <p>{socialMediaLabel}</p>
          <div class="social__icons">
            {Object.entries(socialMediaLinks).map(
              ([key, social]: any) =>
                social.icon && (
                  <a
                    aria-label={social.altText}
                    target="_blank"
                    rel="noreferrer"
                    href={social.link}
                    key={key}
                    onMouseEnter={() => this.handleOnEnter(key)}
                    onMouseLeave={() => this.handleOnLeave()}
                    onClick={() => this.handleTracking(social)}
                  >
                    <div class="social__icon">
                      <img
                        src={social.icon}
                        alt={social.altText}
                        style={!this.highContrast || (this.highContrast && this.currentKey === key) ? null : { filter: 'invert(1)' }}
                      />
                    </div>
                  </a>
                ),
            )}
          </div>
        </div>
      </Host>
    );
  }
}
